module.exports = __webpack_public_path__ + "img/logo-qb.fd155fb0.png";